"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var value_checker_1 = __importDefault(require("../validation/value_checker"));
var DateParser = /** @class */ (function () {
    function DateParser() {
    }
    DateParser.toJapaneseNenGetsu = function (date, format) {
        if (format === void 0) { format = 'YYYY年MM月'; }
        var year_str = date.getFullYear();
        //月だけ+1すること
        var month_str = 1 + date.getMonth();
        var format_str = format;
        format_str = format_str.replace(/YYYY/g, String(year_str));
        format_str = format_str.replace(/MM/g, String(month_str));
        return format_str;
    };
    /**
     *
     * @param time
     */
    DateParser.toJapaneseDateStrFromTime = function (time) {
        return new Intl.DateTimeFormat('ja-JP', {
            year: 'numeric',
            month: 'narrow',
            day: 'numeric'
        }).format(time);
    };
    /**
     *
     * @param date
     * @returns {string} YYYY-MM-DD
     */
    DateParser.toString = function (date) {
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var monthStr = month < 10 ? "0" + month : String(month);
        var dayStr = day < 10 ? "0" + day : String(day);
        return date.getFullYear() + "-" + monthStr + "-" + dayStr;
    };
    /**
     *
     * @param dateStr {String} YYYY-MM-DD形式の文字列
     * @return {String} YYYY年MM月DD日
     */
    DateParser.toJapaneseDateStr = function (dateStr) {
        if (value_checker_1.default.isBlank(dateStr)) {
            return '';
        }
        try {
            return DateParser.toJapaneseDateStrFromTime(Date.parse(dateStr));
        }
        catch (e) {
            console.log(e);
            return '';
        }
    };
    DateParser.toJapaneseDateStrNenGetu = function (dateStr) {
        if (value_checker_1.default.isBlank(dateStr)) {
            return '';
        }
        try {
            var dateTime = Date.parse(dateStr);
            var date = new Date(dateTime);
            return date.getFullYear() + "\u5E74" + (date.getMonth() + 1) + "\u6708";
        }
        catch (e) {
            console.log(e);
            return '';
        }
    };
    /**
     *
     * @param dateStr {String} YYYY-MM-DD形式の文字列
     * @return {String} 平成○○年○○月○○日
     */
    DateParser.toWarekiDateStr = function (dateStr) {
        if (!dateStr) {
            return '';
        }
        try {
            return new Intl.DateTimeFormat('ja-JP-u-ca-japanese', {
                year: 'numeric',
                month: 'narrow',
                day: 'numeric',
                era: 'long'
            }).format(Date.parse(dateStr));
        }
        catch (e) {
            console.log(e);
            return '';
        }
    };
    return DateParser;
}());
exports.default = DateParser;



//////////////////
// WEBPACK FOOTER
// ./common/src/utils/date/date_parser.ts
// module id = ZQoP
// module chunks = 1